module.exports = __webpack_public_path__ + "img/chiffre-3.a6cebc30.svg";